/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumRichiestaDTOTipoIntegrazione =
  (typeof EnumRichiestaDTOTipoIntegrazione)[keyof typeof EnumRichiestaDTOTipoIntegrazione];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumRichiestaDTOTipoIntegrazione = {
  NESSUNA: 'NESSUNA',
  INTEGRAZIONE_VOLONTARIA: 'INTEGRAZIONE_VOLONTARIA',
  RICHIESTA_INTEGRAZIONE: 'RICHIESTA_INTEGRAZIONE',
} as const;
